import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export default class GetAlertSearchAdsService extends Service {
  /**
   * @constructor
   * @param {Object} params
   * @param {Config} params.config
   * @param {AdEntityToAdSearchParamsVOMapper} params.adEntityToAdSearchParamsVOMapper
   */
  constructor({config, adEntityFactory, adEntityToAdSearchParamsVOMapper}) {
    super()

    this._config = config
    this._adEntityFactory = adEntityFactory
    this._adEntityToAdSearchParamsVOMapper = adEntityToAdSearchParamsVOMapper
  }

  /**
   * Returns a search value object related to an ad so we can create an alert
   * @return {Promise<AdsSearchParamsValueObject, Error>}
   */
  @inlineError
  async execute({ad, params}) {
    const adEntity = this._adEntityFactory({...ad})

    return this._adEntityToAdSearchParamsVOMapper.setParams({params}).map({adEntity})
  }
}
